(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DESKTOP = window.matchMedia('(min-width: 900px)');
  var CAN_CLIP = !!(window.CSS && CSS.supports && CSS.supports('overflow', 'clip'));
  var INTRO_VIDEO = 'https://d2ol7oe51mr4n9.cloudfront.net/user_3G23CDEG9iVF2CMXwd09QrkUnxe/31024a08-a447-4343-a06b-b752979211cb.mp4';
  var STYLE_ID = 'vis2-intro-video-style';

  function clamp01(value) {
    if (value < 0) return 0;
    if (value > 1) return 1;
    return value;
  }

  function unlockSticky() {
    var pc = document.getElementById('PageContainer');
    if (pc && CAN_CLIP) pc.style.overflow = 'clip';
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.vis2__intro{position:relative;min-height:100svh;display:grid;align-items:center;overflow:hidden;padding-block:0;background:#050403}',
      '.vis2__intro::before{content:"";position:absolute;inset:0;z-index:1;pointer-events:none;background:linear-gradient(to right,rgba(0,0,0,.56) 0%,rgba(0,0,0,.36) 40%,rgba(0,0,0,.04) 72%,rgba(0,0,0,.12) 100%),linear-gradient(to bottom,rgba(0,0,0,.34) 0%,rgba(0,0,0,.04) 46%,rgba(0,0,0,.42) 100%)}',
      '.vis2__intro-video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center;z-index:0;opacity:1;filter:none;transform:scale(1.01)}',
      /* HIS NOTE: vispring and all the text should be on more left.
         The old value here was max-width:780px, which made .sh-wrap auto
         margins CENTRE the whole column. Widening the box past the viewport
         pins it to the left gutter instead, and the logotype and copy move
         together because they share this one left edge. The logotype own
         width is untouched - logo must remain same. */
      '.vis2__intro-inner{position:relative;z-index:2;padding-block:clamp(96px,11vw,150px);max-width:1720px}',
      /* HIS NOTE: typography a bit smaller but readable. The display sizes
         come down to tighten the hierarchy; the two SMALLEST styles go UP,
         because 12px body and 9px marks were at or below the readable floor -
         shrinking those would have cost legibility, not gained polish. */
      '.vis2__intro .vis2__h1{font-size:clamp(26px,2.35vw,40px);line-height:1.1;max-width:19ch;font-weight:300}',
      '.vis2__intro .vis2__sub{font-size:clamp(11px,.74vw,13px);letter-spacing:.2em;text-transform:uppercase;margin-top:clamp(18px,2vw,26px);color:rgba(242,241,237,.8)}',
      '.vis2__intro .vis2__body{font-size:clamp(13px,.82vw,15px);line-height:1.62;max-width:44ch;margin-top:clamp(16px,1.8vw,24px);color:rgba(242,241,237,.78)}',
      '.vis2__intro .vis2__badges{margin-top:clamp(22px,2.8vw,34px);gap:10px clamp(18px,2.2vw,30px);max-width:680px}',
      '.vis2__intro .vis2__badges li{font-size:clamp(10px,.66vw,11.5px);letter-spacing:.22em;color:rgba(242,241,237,.82)}',
      '.vis2__film-track{display:none}',
      /* ---- 03 + 04 THE SPLIT -------------------------------------------
         REMOVED FROM HERE, DO NOT PUT THEM BACK:
           height:clamp(330px,46svh,410px) on .vis2__pair
           height:clamp(315px,44svh,380px) on .vis2__panel
         Both columns were pinned to about 400px inside a 100svh row, which
         left the ~490px of black under them. Heights are gone; the columns
         now stretch to the row.
           .vis2__pair-bg inset with left:clamp(275px,50%,575px);width:auto
         turned the photograph into a small inset card floating in the middle
         of the column. It is full-bleed again below.
           padding-right:min(52vw,620ppx) - 620ppx is not a length, so the
         whole declaration was dropped by the parser. Gone.
         HIS NOTE: the picture should be much more visible and the lady must
         be visible. The woman sits at about 78-90% across the source frame,
         so object-position moves to 78% to hold her AND the bed; and the
         scrim drops from .84 to .72 and clears by 84% instead of 100%, so
         the right of the photograph keeps its own light. */
      '.vis2__pair{min-height:0;box-sizing:border-box;display:grid;align-items:center;overflow:hidden;background:#050403;padding:clamp(40px,4.5vw,80px) clamp(28px,3.4vw,68px)}',
      '.vis2__pair-bg{inset:0;width:100%;height:100%;object-fit:cover;object-position:78% 50%;opacity:1}',
      '.vis2__pair-veil{background:linear-gradient(to right,rgba(0,0,0,.72) 0%,rgba(0,0,0,.60) 36%,rgba(0,0,0,.24) 62%,rgba(0,0,0,0) 84%),linear-gradient(to top,rgba(0,0,0,.26),rgba(0,0,0,0) 55%)}',
      '.vis2__pair-inner{width:100%;max-width:none;margin:0;padding:0}',
      '.vis2__pair-logo{display:none!important}',
      '.vis2__pair .vis2__eyebrow{font-size:clamp(11px,.8vw,13.5px);letter-spacing:.3em;margin-bottom:clamp(14px,1.8vw,22px);color:rgba(242,241,237,.88)}',
      /* HIS NOTE: vispring x spicy part should be more dominant. Three
         levers at once - the heading goes back up (Codex had capped it at
         40px/13ch, which made it SMALLER than the panel beside it), the
         column gets wider below, and it keeps the photograph. */
      '.vis2__pair .vis2__h1{font-size:clamp(30px,3.1vw,54px);line-height:1.05;max-width:17ch}',
      '.vis2__pair .vis2__body{font-size:clamp(13.5px,.88vw,16px);line-height:1.58;max-width:46ch;margin-top:clamp(16px,2vw,24px);color:rgba(242,241,237,.86)}',
      '.vis2__btn{margin-top:clamp(20px,2.4vw,30px);padding:.78rem 2rem}',
      /* Ground stays his Off White - var(--vis2-panel) is untouched. */
      '.vis2__panel{min-height:0;box-sizing:border-box;padding:clamp(44px,4.6vw,80px) clamp(26px,3vw,58px);position:relative;display:grid;align-items:center}',
      '.vis2__panel-inner{gap:clamp(22px,2.8vw,38px);min-height:0}',
      '.vis2__panel-text{align-self:center}',
      '.vis2__panel .vis2__eyebrow{font-size:clamp(10px,.72vw,12px);letter-spacing:.32em;margin-bottom:clamp(10px,1.3vw,15px)}',
      '.vis2__panel .vis2__h2{font-size:clamp(23px,1.95vw,34px);line-height:1.1}',
      '.vis2__panel .vis2__body{font-size:clamp(13px,.88vw,15px);line-height:1.56;max-width:42ch;margin-top:clamp(12px,1.6vw,18px)}',
      '.vis2__panel-media{justify-self:stretch;width:100%}',
      '.vis2__panel-media img{aspect-ratio:16/10;object-fit:cover;box-shadow:0 18px 44px rgba(41,36,33,.14)}',
      /* Both on one screen, side by side, with the pair the wider of the two
         (1.85fr vs the previous 1.62fr). */
      '@media(min-width:900px){.vis2__split{grid-template-columns:1.85fr 1fr;min-height:100svh;align-items:stretch}.vis2__pair,.vis2__panel{min-height:100svh}}',
      '.vis2__row,.vis2__row-track,.vis2__row-stage{background:#f2ede7!important;color:#171310!important}',
      '[data-vis2-row-mode="dock"] .vis2__row-track{height:112svh!important}',
      '[data-vis2-row-mode="dock"] .vis2__row-stage{height:72svh!important;justify-content:center!important;padding-block:clamp(20px,3vw,36px)!important;overflow:hidden}',
      '.vis2__row-head{position:relative;z-index:2;margin-bottom:clamp(14px,2vw,24px)}',
      '.vis2__row-stage .vis2__eyebrow{color:rgba(128,46,45,.78)!important}',
      '.vis2__row-stage .sh-dot{background:#b34448!important}',
      '.vis2__row-stage .vis2__h2{font-size:clamp(26px,2.5vw,42px);line-height:1.06;color:#171310!important}',
      '.vis2__card{--vis2-lift:-6px;opacity:calc(.9 + var(--dock,0) * .1)}',
      '.vis2__card:nth-child(2){--vis2-lift:-11px}',
      '.vis2__card:nth-child(3){--vis2-lift:-16px}',
      '.vis2__card-media{background:#e5ddd4!important;box-shadow:0 12px 30px rgba(50,39,31,.08)}',
      '.vis2__card-media img{aspect-ratio:16/8.2;border-radius:0!important;transform:scale(calc(1 + var(--dock,0) * .035));transform-origin:center center;will-change:transform}',
      '.vis2__row-stage .vis2__num{color:#9e4d4d!important}',
      '.vis2__row-stage .vis2__h3{font-size:clamp(18px,1.4vw,24px);line-height:1.1;color:#171310!important}',
      '.vis2__row-stage .vis2__small{font-size:clamp(13px,.95vw,16px);line-height:1.45;color:rgba(23,19,16,.68)!important}',
      '[data-vis2-row-mode="dock"] .vis2__card{transform:translate3d(0,calc(var(--dock,0) * var(--vis2-lift)),0)!important;transform-origin:center center!important;will-change:transform,opacity}',
      '[data-vis2-row-mode="dock"] .vis2__card-text{opacity:1!important}',
      '.vis2__tiles{padding-block:clamp(38px,5.5vw,72px)}',
      '.vis2__tiles-head{margin-bottom:clamp(20px,3vw,34px)}',
      '.vis2__tiles-note{max-width:48ch}',
      '.vis2__tile-link{aspect-ratio:4/3}',
      '.vis2__tile-label{bottom:clamp(12px,1.8vw,20px);font-size:clamp(17px,1.45vw,24px)}',
      /* Stacked. The photograph becomes a real 16/10 picture under the copy
         rather than a background, and the scrim goes vertical because the
         copy is full-bleed here and a horizontal ramp would protect nothing. */
      '@media(max-width:899px){.vis2__pair{min-height:auto;padding-block:clamp(34px,10vw,58px)}.vis2__pair-bg{position:relative;inset:auto;width:100%;height:auto;aspect-ratio:16/10;margin-top:28px;order:2;object-position:78% 50%}.vis2__pair-veil{background:linear-gradient(to bottom,rgba(0,0,0,.58),rgba(0,0,0,.12))}.vis2__pair-inner{padding-right:0}.vis2__panel-inner{min-height:auto}.vis2__panel-media{justify-self:stretch}}',
      /* opacity on the film stays 1 at EVERY width. His note was that the
         video must be brighter without its colour being touched, and an
         opacity below 1 blends the picture into the black behind it, which
         desaturates it. The .58 that was here is the exact thing he asked to
         have removed. All darkening is done by the scrim above. */
      '@media(max-width:767px){.vis2__intro{min-height:92svh}.vis2__intro-video{opacity:1;object-position:center}.vis2__intro .vis2__h1{font-size:clamp(28px,8.6vw,38px)}.vis2__intro .vis2__body{max-width:36ch}}'
    ].join('');
    document.head.appendChild(style);
  }

  function initIntro(root) {
    var intro = root.querySelector('.vis2__intro');
    if (!intro || intro.querySelector('.vis2__intro-video')) return;
    var video = document.createElement('video');
    video.className = 'vis2__intro-video';
    video.src = INTRO_VIDEO;
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.autoplay = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('preload', 'metadata');
    video.setAttribute('aria-hidden', 'true');
    video.setAttribute('tabindex', '-1');
    intro.insertBefore(video, intro.firstChild);
    var play = video.play();
    if (play && play.catch) play.catch(function () {});
  }

  function initRow(root) {
    var track = root.querySelector('[data-vis2-row-track]');
    if (!track || REDUCED || !DESKTOP.matches || !CAN_CLIP) {
      root.setAttribute('data-vis2-row-mode', 'static');
      return;
    }
    root.setAttribute('data-vis2-row-mode', 'dock');
    unlockSticky();

    var top = 0;
    var span = 1;
    var last = -1;

    function measure() {
      var rect = track.getBoundingClientRect();
      top = rect.top + window.pageYOffset;
      span = Math.max(1, track.offsetHeight - window.innerHeight);
    }

    function paint(scroll) {
      var p = clamp01((scroll - top) / span);
      if (Math.abs(p - last) < 0.0015) return;
      last = p;
      var dock = clamp01((p - 0.08) / 0.78);
      var eased = dock * dock * (3 - 2 * dock);
      root.style.setProperty('--dock', eased.toFixed(4));
    }

    measure();
    if (window.SpicyScroll) {
      window.SpicyScroll.onScroll(function (metrics) {
        paint(metrics.scroll);
      });
    } else {
      window.addEventListener('scroll', function () {
        paint(window.pageYOffset);
      }, { passive: true });
    }
    window.addEventListener('resize', function () {
      measure();
      last = -1;
      paint(window.pageYOffset);
    }, { passive: true });
    window.addEventListener('load', function () {
      measure();
      last = -1;
      paint(window.pageYOffset);
    }, { once: true });
    paint(window.pageYOffset);
  }

  function init(root) {
    if (root.__vis2Booted) return;
    root.__vis2Booted = true;
    injectStyles();
    initIntro(root);
    initRow(root);
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-vis2]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    }, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
